import { useState, useEffect } from 'react';
import moment from 'moment';

let timer: NodeJS.Timer;
const getCurDateHook = (value: number) => {
  const [state, setState] = useState(value);
  useEffect(() => {
    timer = setInterval(() => {
      setState(moment().startOf('d').valueOf());
    }, 10 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return state;
};

export default getCurDateHook;
